import { OptionsConstants } from '../config/constants/OptionsConstants';
import * as util from './utilitys';

export const getChartColors = (count) => {
        const antDesignColors = [
            '#5B8FF9', '#61DDAA', '#65789B', '#F6BD16', '#7262fd',
            '#78D3F8', '#9661BC', '#F6903D', '#008685', '#F08BB4'
        ];
        return antDesignColors.slice(0, count);
};

/**
 * @typedef {`#${string}`} HexColor
 */

/**
 * @param {"1"|"2"|"3"|"4"|"5"|"6"|"7"|"8"|"9"|"10"} set - Allowed values: "1" ถึง "10"
 * @param {number} [opacity=0.1] - Opacity between 0 and 1
 * @param {HexColor} [customColor] - Hex color only (e.g. #fff, #ffffff)
 */
export const getChartColorSet = (
  set = "1",
  opacity = 0.1,
  customColor
) => {
  if (!["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].includes(set)) {
    throw new Error(`Invalid set: ${set}`);
  }

  const hexToRgba = (hex, alpha = 1) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r},${g},${b},${alpha})`;
  };

//   const colors = {
//     "1": "#3a78f9",
//     "2": "#AEAEAE",
//     "3": "#dc3545",
//     "4": "#DCA735",
//     "5": "#35D9DC",
//   };

  const colors = {
    "1": "#3a78f9",
    "2": "#AEAEAE",
    "3": "#dc3545",
    "4": "#DCA735",
    "5": "#35D9DC",
    "6": "#78D3F8",
    "7": "#9661BC",
    "8": "#F6903D",
    "9": "#008685",
    "10": "#F08BB4",
  };

  const baseColor = customColor || colors[set];

  return {
    borderColor: hexToRgba(baseColor, 1),
    backgroundColor: hexToRgba(baseColor, 0.25),
    valueOpacity: hexToRgba(baseColor, opacity),
  };
};

export const getCellBgColor = (value, max, baseSet = '1') => {
  if (!max || isNaN(value)) return undefined;

  const ratio = value / max; // 0 - 1
  const minOpacity = 0.05;
  const maxOpacity = 0.35;

  const opacity =
    minOpacity + (maxOpacity - minOpacity) * ratio;

  return getChartColorSet(baseSet, opacity).valueOpacity;
};

export const getRowMax = (row, columns) => {
  return Math.max(
    ...columns
      .filter(col => col !== 'ปี' && col !== 'รวม')
      .map(col => Number(row[col]) || 0)
  );
};

export const summarizeUsersOverall = (dashboardUsersOverall) => {
    return dashboardUsersOverall.reduce((acc, { source_table, rows }) => {
        if (!acc[source_table]) {
            acc[source_table] = { source_table, total_rows: 0 };
        }
        acc[source_table].total_rows += rows;
        return acc;
    }, {});
}

export const usersInDetailsChartData = (rawData) => {
    const typesMap = {
        0: 'SUPER ADMIN',
        1: 'ADMIN SYSTEM',
        2: 'USER EDU',
        3: 'USER ENT',
        4: 'EXTERNAL USER'
    };

    const statusOptions = {
        users: ['0', '1', '2'],
        external_user: ['0', '1', '2', '3']
    };

    const statusMeta = {
        users: {
            0: 'อนุมัติการใช้งาน',
            1: 'ไม่อนุมัติการใช้งาน',
            2: 'พักการใช้งาน'
        },
        external_user: {
            0: 'อนุมัติการใช้งาน',
            1: 'ไม่อนุมัติการใช้งาน',
            2: 'ลงทะเบียนใหม่',
            3: 'พักการใช้งาน'
        }
    };

    const chartDataMap = {};

    Object.entries(typesMap).forEach(([typeKey, typeLabel]) => {
        const source = typeKey === '4' ? 'external_user' : 'users';
        const allowedStatuses = statusOptions[source];
        const labelsMap = statusMeta[source];

        const filtered = rawData.filter(
            row =>
                row.source_table === source &&
                row.types === typeKey &&
                allowedStatuses.includes(row.status)
        );

        const grouped = filtered.reduce((acc, row) => {
            const label = labelsMap[row.status];
            if (!label) return acc;
            acc[label] = (acc[label] || 0) + (row.rows || 0);
            return acc;
        }, {});

        chartDataMap[typeKey] = {
            title: typeLabel,
            labels: Object.keys(grouped),
            data: Object.values(grouped)
        };
    });

    return chartDataMap;
};

/* Section A */ 
    export const academyTopBudgetDoughnutChart = (rawData = []) => {

        // group ตาม academy_id
        const groupedData = Object.values(

            rawData.reduce((acc, item) => {

                const key = String(item.academy_id).trim();

                if (!acc[key]) {
                    acc[key] = {
                        academy_id: key,
                        academy_name: item.academy_name,
                        total_budget: 0
                    };
                }

                // รวมทุกเดือน
                acc[key].total_budget += Number(item.budget_request || 0);

                return acc;

            }, {})

        );

        // top 10
        const top10 = groupedData
            .sort((a, b) => b.total_budget - a.total_budget)
            .slice(0, 10);

        return {
            labels: top10.map(item => item.academy_name),

            datasets: [
                {
                    label: 'งบประมาณ',

                    data: top10.map(item => item.total_budget),

                    backgroundColor: top10.map((_, index) =>
                        getChartColorSet(String((index % 10) + 1)).backgroundColor
                    ),

                    borderColor: top10.map((_, index) =>
                        getChartColorSet(String((index % 10) + 1)).borderColor
                    ),

                    borderWidth: 1
                }
            ]
        };
    };
    export const budgetRequestChart = (rawData = []) => {

        // labels เดือน
        const monthLabels =
            OptionsConstants.variables.months.th.sn;

        const monthNumbers =
            Array.from({ length: 12 }, (_, i) => i + 1);

        // group academy ด้วย id
        const academyMap = {};

        rawData.forEach(item => {

            const academyId =
                String(item.academy_id).trim();

            if (!academyMap[academyId]) {
                academyMap[academyId] = {
                    academy_id: academyId,
                    academy_name: item.academy_name
                };
            }
        });

        const academies = Object.values(academyMap);

        const datasets = academies.map((academy, index) => {

            // เตรียม 12 เดือน
            const monthData = Array(12).fill(0);

            rawData.forEach(item => {

                const academyId =
                    String(item.academy_id).trim();

                const month =
                    Number(item.months);

                // skip invalid
                if (
                    academyId !== academy.academy_id ||
                    month < 1 ||
                    month > 12
                ) {
                    return;
                }

                const monthIndex = month - 1;

                monthData[monthIndex] +=
                    Number(item.budget_request || 0);
            });

            return {
                label: academy.academy_name,

                data: monthData,

                borderColor:
                    getChartColorSet(
                        String((index % 10) + 1)
                    ).borderColor,

                backgroundColor:
                    getChartColorSet(
                        String((index % 10) + 1)
                    ).backgroundColor,

                fill: true,

                stack: 'total'
            };
        });

        return {
            labels: monthLabels,
            datasets
        };
    };
    export const budgetRequestData = (rawData = []) => {
        const rows = rawData.map(item => ({
            years: item.years,
            months: item.months,
            academy_id: item.academy_id,
            academy_name: item.academy_name,
            budget_request: Number(item.budget_request || 0)
        }));

        return {
            rows,
            page: 1,
            pageSize: rows.length,
            totalRows: rows.length
        };
    };
    
    export const academyTopTraineeResultDoughnutChart = (rawData = []) => {

        // group ตาม academy_id
        const groupedData = Object.values(

            rawData.reduce((acc, item) => {

                const key = String(item.academy_id).trim();

                if (!acc[key]) {
                    acc[key] = {
                        academy_id: key,
                        academy_name: item.academy_name,
                        total_budget: 0
                    };
                }

                // รวมทุกเดือน
                acc[key].total_budget += Number(item.person_amount || 0);

                return acc;

            }, {})

        );

        // top 10
        const top10 = groupedData
            .sort((a, b) => b.total_budget - a.total_budget)
            .slice(0, 10);

        return {
            labels: top10.map(item => item.academy_name),

            datasets: [
                {
                    label: 'งบประมาณ',

                    data: top10.map(item => item.total_budget),

                    backgroundColor: top10.map((_, index) =>
                        getChartColorSet(String((index % 10) + 1)).backgroundColor
                    ),

                    borderColor: top10.map((_, index) =>
                        getChartColorSet(String((index % 10) + 1)).borderColor
                    ),

                    borderWidth: 1
                }
            ]
        };
    };
    export const traineeResultChart = (rawData = []) => {
        const monthLabels =
            OptionsConstants.variables.months.th.sn;

        const monthNumbers =
            Array.from({ length: 12 }, (_, i) => i + 1);

        const academyMap = {};

        rawData.forEach(item => {

            const academyId = String(item.academy_id).trim();

            if (!academyMap[academyId]) {
                academyMap[academyId] = {
                    academy_id: academyId,
                    academy_name: item.academy_name
                };
            }
        });

        const academies = Object.values(academyMap);

        const datasets = academies.map((academy, index) => {

            // default 12 เดือน
            const monthData = Array(12).fill(0);

            rawData.forEach(item => {

                const academyId =
                    String(item.academy_id).trim();

                const month =
                    Number(item.months);

                // skip invalid month
                if (
                    academyId !== academy.academy_id ||
                    month < 1 ||
                    month > 12
                ) {
                    return;
                }

                // index เดือน
                const monthIndex = month - 1;

                monthData[monthIndex] +=
                    Number(item.person_amount || 0);
            });

            return {
                label: academy.academy_name,

                data: monthData,

                borderColor:
                    getChartColorSet(String((index % 10) + 1)).borderColor,

                backgroundColor:
                    getChartColorSet(String((index % 10) + 1)).backgroundColor,

                fill: true,

                stack: 'total'
            };
        });

        return {
            labels: monthLabels,
            datasets
        };
    };
    export const traineeResultData = (rawData = []) => {
        const rows = rawData.map(item => ({
            years: item.years,
            months: item.months,
            academy_id: item.academy_id,
            academy_name: item.academy_name,
            person_amount: Number(item.person_amount || 0)
        }));

        return {
            rows,
            page: 1,
            pageSize: rows.length,
            totalRows: rows.length
        };
    };

    export const traineeResultByIndustryChart = (rawData = []) => {
        const monthLabels =
            OptionsConstants.variables.months.th.sn;

        const monthNumbers =
            Array.from({ length: 12 }, (_, i) => i + 1);

        const target_industriesMap = {};

        rawData.forEach(item => {

            const target_industriesId = String(item.target_industries_id).trim();

            if (!target_industriesMap[target_industriesId]) {
                target_industriesMap[target_industriesId] = {
                    target_industries_id: target_industriesId,
                    target_industries_name: item.target_industries_name
                };
            }
        });

        const target_industries = Object.values(target_industriesMap);

        const datasets = target_industries.map((target_industries, index) => {

            // default 12 เดือน
            const monthData = Array(12).fill(0);

            rawData.forEach(item => {

                const target_industriesId =
                    String(item.target_industries_id).trim();

                const month =
                    Number(item.months);

                // skip invalid month
                if (
                    target_industriesId !== target_industries.target_industries_id ||
                    month < 1 ||
                    month > 12
                ) {
                    return;
                }

                // index เดือน
                const monthIndex = month - 1;

                monthData[monthIndex] +=
                    Number(item.person_amount || 0);
            });

            return {
                label: target_industries.target_industries_name,

                data: monthData,

                borderColor:
                    getChartColorSet(String((index % 10) + 1)).borderColor,

                backgroundColor:
                    getChartColorSet(String((index % 10) + 1)).backgroundColor,

                fill: true,

                stack: 'total'
            };
        });

        return {
            labels: monthLabels,
            datasets
        };
    };
    export const traineeResultByIndustryData = (rawData = []) => {
        const rows = rawData.map(item => ({
            years: item.years,
            months: item.months,
            target_industries_id: item.target_industries_id,
            target_industries_name: item.target_industries_name,
            person_amount: Number(item.person_amount || 0)
        }));

        return {
            rows,
            page: 1,
            pageSize: rows.length,
            totalRows: rows.length
        };
    };
    
    export const budgetByIndustriesChart = (rawData = []) => {

        const monthLabels =
            OptionsConstants.variables.months.th.sn;

        const monthNumbers =
            Array.from({ length: 12 }, (_, i) => i + 1);

        // group industries
        const industriesMap = {};

        rawData.forEach(item => {

            const industryName =
                String(item.th_name || '').trim();

            if (!industryName) return;

            if (!industriesMap[industryName]) {
                industriesMap[industryName] = {
                    th_name: industryName
                };
            }
        });

        const industries =
            Object.values(industriesMap);

        const datasets = industries.map((industry, index) => {

            // เตรียม 12 เดือน
            const monthData = Array(12).fill(0);

            rawData.forEach(item => {

                const industryName =
                    String(item.th_name || '').trim();

                const month =
                    Number(item.months);

                // skip invalid
                if (
                    industryName !== industry.th_name ||
                    month < 1 ||
                    month > 12
                ) {
                    return;
                }

                const monthIndex = month - 1;

                monthData[monthIndex] +=
                    Number(item.budget_request || 0);
            });

            return {
                label: industry.th_name,

                data: monthData,

                borderColor:
                    getChartColorSet(
                        String((index % 10) + 1)
                    ).borderColor,

                backgroundColor:
                    getChartColorSet(
                        String((index % 10) + 1)
                    ).backgroundColor,

                stack: 'total'
            };
        });

        return {
            labels: monthLabels,
            datasets
        };
    };
    export const budgetByIndustriesData = (rawData = []) => {
        const rows = rawData.map(item => ({
            years: item.years,
            months: item.months,
            th_name: item.th_name,
            budget_request: Number(item.budget_request || 0)
        }));

        return {
            rows,
            page: 1,
            pageSize: rows.length,
            totalRows: rows.length
        };
    };
/* End Section A */

/* Section B */ 
    export const trainedCourseData = (rawData = []) => {
        const rows = rawData.map(item => ({
            id: item.id,
            th_name: item.th_name,
            model_no: Number(item.model_no || 0),
            person_amount: Number(item.person_amount || 0)
        }));

        return {
            rows,
            page: 1,
            pageSize: rows.length,
            totalRows: rows.length
        };
    };
    
    export const notTrainedCourseData = (rawData = []) => {
        const rows = rawData.map(item => ({
            id: item.id,
            th_name: item.th_name,
        }));

        return {
            rows,
            page: 1,
            pageSize: rows.length,
            totalRows: rows.length
        };
    };
/* End Section B */

export const ebUserTrainingByMonth = (rawData) => {
    const monthNumbers = [...new Set(rawData.map(d => d.months))].sort((a, b) => a - b);

    const labels = monthNumbers.map(m => OptionsConstants.variables.months.th.sn[m - 1]);

    const seriesMap = {};

    rawData.forEach(({ name, months, amount }) => {
        if (!seriesMap[name]) {
            seriesMap[name] = {};
        }
        seriesMap[name][months] = amount;
    });

    const color = getChartColors();

    const datasets = Object.entries(seriesMap).map(([name, monthMap], i) => ({
        label: name,
        data: monthNumbers.map(month => monthMap[month] || 0),
        fill: false,
        borderColor: color[i % color.length],
        tension: 0.4
    }));

    return {
        labels, 
        datasets
    };
};

export const ebUserTrainingByIndustries = (rawData) => {
  const currentYear = new Date().getFullYear() + 543; 

  const summary = {};

  rawData.forEach(({ name, amount, years }) => {
    if (years !== currentYear) return;

    if (!summary[name]) {
      summary[name] = 0;
    }

    summary[name] += amount || 0;
  });

  const labels = Object.keys(summary);
  const data = labels.map(name => summary[name]);

  return {
    labels,
    datasets: [
      {
        data
      }
    ]
  };
};

export const summarizeEducationLevelInfo = (educationLevel) => {

    const currentYear = new Date().getFullYear() + 543;

    const summaryMap = {};

    educationLevel.forEach((item) => {

        const years = Number(item.years);
        const groupName = item.groupName;
        const amount = Number(item.release_amount || 0);

        if (years !== currentYear) return;

        if (!summaryMap[groupName]) {
            summaryMap[groupName] = 0;
        }

        summaryMap[groupName] += amount;
    });

    const labels = Object.keys(summaryMap);
    const data = labels.map(name => summaryMap[name]);

    return {
        labels,
        datasets: [
            {
                label: "จำนวนผลผลิตกำลังคน",
                data,
                backgroundColor: getChartColors(labels.length),
                borderWidth: 1
            }
        ]
    };
};


export const summarizeTrainingInfo = (trainingSummaryInfo) => {
    let currentYear = new Date().getFullYear();

    currentYear = String(currentYear + 543);

    return trainingSummaryInfo.reduce((acc, item) => {
        if (String(item.years) === currentYear) {
        acc.user_training_amount += item.user_training_amount || 0;
        acc.course_amount += item.course_amount || 0;
        acc.industries_amount += item.industries_amount || 0;
        acc.budget_amount += item.budget_amount || 0;
        }
        return acc;
    }, {
        years: currentYear,
        user_training_amount: 0,
        course_amount: 0,
        industries_amount: 0,
        budget_amount: 0
    });
};

export const summarizeBudgetByIndustriesInfo = (rawData) => {
    const currentYear = new Date().getFullYear();

    const summaryMap = {};

    rawData.forEach(({ name, years, budget_amount, course_amount }) => {
        if (years !== currentYear) return;

        if (!summaryMap[name]) {
        summaryMap[name] = {
            budget: 0,
            course: 0
        };
        }

        summaryMap[name].budget += budget_amount || 0;
        summaryMap[name].course += course_amount || 0;
    });

    const labels = Object.keys(summaryMap);
    const budgetData = labels.map(name => summaryMap[name].budget);
    const courseData = labels.map(name => summaryMap[name].course);

    return {
        labels,
        datasets: [
        {
            label: 'งบประมาณ',
            data: budgetData,
        },
        {
            label: 'จำนวนหลักสูตร',
            data: courseData,
        }
        ]
    };
};

export const summarizeBudgetByIndustries = (rawData) => {
    const currentYear = new Date().getFullYear(); // or +543 if using BE
    const summaryMap = {};

    rawData.forEach(({ name, years, budget_amount = 0 }) => {
        if (years !== currentYear) return;

        if (!summaryMap[name]) {
        summaryMap[name] = 0;
        }

        summaryMap[name] += budget_amount;
    });

    const labels = Object.keys(summaryMap);
    const data = labels.map(name => summaryMap[name]);

    return {
        labels,
        datasets: [
        {
            label: 'งบประมาณ',
            data,
            backgroundColor: getChartColors(labels.length),
            borderWidth: 1
        }
        ]
    };
};

export const eb01Info = (rawData) => {
  const STATUS_OPTIONS = {
    '0': 'รับรองหลักสูตร',
    '1': 'รับรองหลักสูตรแบบมีเงื่อนไข',
    '2': 'ไม่รับรองหลักสูตร',
    '': 'ไม่ระบุ'
  };


  const OPERATION_OPTIONS = {
    '0': 'รอเสนอ',
    '1': 'รอการแก้ไข',
    '2': 'แก้ไขเสร็จสิ้น',
    '3': 'รอการพิจารณา',    
    '': 'ไม่ระบุ'
  };

  const statusSummary = {};
  const nameSummary = {};

  rawData.forEach(({ operation, status, name, rows }) => {
    const op = operation ?? '';
    const st = status ?? '';

    let statusLabel = '';

    // apply your rules
    if (op === '3' && st !== '') {
      statusLabel = STATUS_OPTIONS[st] || 'ไม่ระบุ';
    } else if (op === '3' && st === '') {
      statusLabel = OPERATION_OPTIONS['3']; // รอการพิจารณา
    } else if (st === '') {
      statusLabel = OPERATION_OPTIONS[op] || 'ไม่ระบุ';
    } else {
      statusLabel = STATUS_OPTIONS[st] || 'ไม่ระบุ';
    }

    statusSummary[statusLabel] = (statusSummary[statusLabel] || 0) + (rows || 0);
    nameSummary[name] = (nameSummary[name] || 0) + (rows || 0);
  });

  const pieLabels = Object.keys(statusSummary);
  const pieData = pieLabels.map(label => statusSummary[label]);
  const pieColors = getChartColors(pieLabels.length);

  const pieChart = {
    labels: pieLabels,
    datasets: [
      {
        label: 'สถานะ',
        data: pieData,
        backgroundColor: pieColors,
        borderWidth: 1
      }
    ]
  };

  const barLabels = Object.keys(nameSummary);
  const barData = barLabels.map(name => nameSummary[name]);

  const barChart = {
    labels: barLabels,
    datasets: [
      {
        label: 'จำนวนหลักสูตร',
        data: barData,
        backgroundColor: getChartColors(1)[0] || 'rgba(54, 162, 235, 0.7)'
      }
    ]
  };

  return {
    pieChart,
    barChart
  };
};

export const eb02Info = (rawData) => {
  const STATUS_OPTION = {
    '0': 'ขอจัดอบรม',
    '1': 'อนุมัติจัดอบรม',
    '2': 'อยู่ระหว่างอบรม',
    '3': 'อบรมเสร็จสิ้น',
    '': 'ไม่ระบุ'
  };

  const statusSummary = {};
  const nameSummary = {};

  rawData.forEach(({ status, name, rows }) => {
    const st = status ?? ''; // normalize null/undefined to empty string

    // get status label directly (no operation logic now)
    const statusLabel = STATUS_OPTION[st] || 'ไม่ระบุ';

    statusSummary[statusLabel] = (statusSummary[statusLabel] || 0) + (rows || 0);
    nameSummary[name] = (nameSummary[name] || 0) + (rows || 0);
  });

  const pieLabels = Object.keys(statusSummary);
  const pieData = pieLabels.map(label => statusSummary[label]);
  const pieColors = getChartColors(pieLabels.length);

  const pieChart = {
    labels: pieLabels,
    datasets: [
      {
        label: 'สถานะ',
        data: pieData,
        backgroundColor: pieColors,
        borderWidth: 1
      }
    ]
  };

  const barLabels = Object.keys(nameSummary);
  const barData = barLabels.map(name => nameSummary[name]);

  const barChart = {
    labels: barLabels,
    datasets: [
      {
        label: 'จำนวนหลักสูตร',
        data: barData,
        backgroundColor: getChartColors(1)[0] || 'rgba(54, 162, 235, 0.7)'
      }
    ]
  };

  return {
    pieChart,
    barChart
  };
};

export const typeA100TableData = (rawData = []) => {
    const rows = rawData.map(item => ({
        type: item.profile_type,                 // นักศึกษาเข้าใหม่ / ผู้สำเร็จการศึกษา
        educationLevel: item.education_level_name, // ระดับการศึกษา
        faculty: item.department_name,            // สาขา / คณะ
        industry: item.department_name,           // ถ้า industry ยังไม่มี ใช้ค่าเดียวกันก่อน
        count: Number(item.total_amount || 0),    // จำนวน
        recruit: Number(item.welfare_support || 0) // ผู้สนับสนุน
    }));

    return {
        rows,
        page: 1,
        pageSize: rows.length,
        totalRows: rows.length
    };
};

export const typeADualTableData = (rawData = []) => {
    const rows = rawData.map(item => ({
        type: item.profile_type,                 // นักศึกษาเข้าใหม่ / ผู้สำเร็จการศึกษา
        educationLevel: item.education_level_name, // ระดับการศึกษา
        faculty: item.department_name,            // สาขา / คณะ
        industry: item.target_industries_name,    // ถ้า industry ยังไม่มี ใช้ค่าเดียวกันก่อน
        count: Number(item.student_count || 0),    // จำนวน
    }));

    return {
        rows,
        page: 1,
        pageSize: rows.length,
        totalRows: rows.length
    };
};

export const getLastYearTotal = (chartData, offset = 0) => {
    let total = chartData?.datasets?.reduce((sum, ds) => {
        const dataLength = ds.data.length;
        const value = ds.data[dataLength - 1 - offset] ?? 0;
        return sum + value;
    }, 0);
    return total
};

export const growthTotal = (academyChartData, unit='แห่ง') => {    
    const totalAcademy = getLastYearTotal(academyChartData, 0);
    return totalAcademy === 0 ? '' : `${totalAcademy} ${unit}`;
};

export const growthPercent = (academyChartData) => {
    const totalAcademy = getLastYearTotal(academyChartData, 0);
    const totalLastYear = getLastYearTotal(academyChartData, 1);

    if (totalLastYear === 0) {
        return totalAcademy === 0 ? '' : '(+0.0% จากปีก่อน)';
    }

    const percent =
        ((totalAcademy - totalLastYear) / totalLastYear) * 100;

    const sign = percent >= 0 ? '+' : '-';

    return totalAcademy === 0 ? '' : `(${sign}${Math.abs(percent).toFixed(1)}% จากปีก่อน)`;
};

export const academyChartData = (rawData = []) => {
  const years = [...new Set(
    rawData
      .filter(d => d.chart_year)
      .map(d => d.chart_year)
  )].sort();

  const getDataByType = (type) =>
    years.map(year => {
      const found = rawData.find(
        d => d.chart_year === year && d.education_type === type
      );
      return found ? found.school_total : 0;
    });

  return {
    labels: years,
    datasets: [
      {
        label: 'อาชีวศึกษา',
        data: getDataByType('อาชีวศึกษา'),
        borderColor: getChartColorSet('1').borderColor,
        backgroundColor: getChartColorSet('1').backgroundColor,
        fill: true,
        pointRadius: 3
      },
      {
        label: 'มหาวิทยาลัย',
        data: getDataByType('มหาวิทยาลัย'),
        borderColor: getChartColorSet('2').borderColor,
        backgroundColor: getChartColorSet('2').backgroundColor,
        fill: true,
        pointRadius: 3
      }
    ]
  };
};

export const latestYearAcademyChartData = (rawData = []) => {
  
  const latestYear = rawData
    .filter(d => d.chart_year)
    .map(d => Number(d.chart_year))
    .sort((a, b) => b - a)[0];

  const labels = ['อาชีวศึกษา', 'มหาวิทยาลัย'];

  const data = labels.map(type => {
    const found = rawData.find(
      d =>
        d.chart_year === String(latestYear) &&
        d.education_type === type
    );
    return found ? found.school_total : 0;
  });

  return {
    labels,
    datasets: [
      {
        data,
        borderWidth: 1
      }
    ]
  };
};

export const academyEnumerate = (rawData = [],targetProvinces = ['ชลบุรี', 'ระยอง', 'ฉะเชิงเทรา']) => {
  const years = [...new Set(
    rawData
      .filter(d => d.chart_year)
      .map(d => d.chart_year)
  )].sort();

  const rows = years.map(year => {
    const row = { 'ปี': year };
    let total = 0;

    targetProvinces.forEach(province => {
      const found = rawData.find(
        d =>
          d.chart_year === year &&
          d.province_name === province
      );

      const value = found ? Number(found.school_total) : 0;
      row[province] = String(value);
      total += value;
    });

    row['รวม'] = String(total);
    return row;
  });

  return {
    columnName: ['ปี', ...targetProvinces, 'รวม'],
    rows
  };
};

export const typeAData = (rawData = []) => {
    const currentYear = new Date().getFullYear() + 543; // พ.ศ.
    const startYear = currentYear - 8;

    const years = Array.from(
        { length: currentYear - startYear + 1 },
        (_, i) => String(startYear + i)
    );

    const getDataByType = (type) =>
        years.map(year => {
        const found = rawData.find(
            d =>
            String(d.academic_year) === year &&
            d.student_type === type
        );

        return found ? Number(found.student_count) : 0;
        });

    return {
        labels: years,
        datasets: [
        {
            label: 'เข้าใหม่',
            data: getDataByType('เข้าใหม่'),
            borderColor: getChartColorSet('1').borderColor,
            backgroundColor: getChartColorSet('1').backgroundColor,
            fill: true,
            pointRadius: 3
        },
        {
            label: 'สำเร็จการศึกษา',
            data: getDataByType('สำเร็จการศึกษา'),
            borderColor: getChartColorSet('3').borderColor,
            backgroundColor: getChartColorSet('3').backgroundColor,
            fill: true,
            pointRadius: 3
        }
        ]
    };
};

export const countTypeAByType = (chartData = {}) => {
  const result = {
    'เข้าใหม่': 0,
    'สำเร็จการศึกษา': 0
  };

  (chartData.datasets || []).forEach(ds => {
    const sum = (ds.data || []).reduce((a, b) => a + b, 0);

    if (ds.label === 'เข้าใหม่') {
      result['เข้าใหม่'] = sum;
    }

    if (ds.label === 'สำเร็จการศึกษา') {
      result['สำเร็จการศึกษา'] = sum;
    }
  });

  return result;
};

export const typeADataTable = (rawData = []) => {
  const industryMap = {};

  // 1) รวมข้อมูลตามอุตสาหกรรม
  rawData?.forEach(item => {
    const industry = item.target_industries || 'อื่นๆ';
    const type = item.student_type;
    const count = Number(item.student_count) || 0;

    if (!industryMap[industry]) {
      industryMap[industry] = {
        'อุตสาหกรรม': industry,
        'ทวิภาคี': 0,
        '100%': 0
      };
    }

    if (type === 'ทวิภาคี') {
      industryMap[industry]['ทวิภาคี'] += count;
    }

    if (type === '100%') {
      industryMap[industry]['100%'] += count;
    }
  });

  // 2) สร้าง rows + คำนวณรวม / สัดส่วน
  const rows = [];
  let totalDual = 0;
  let total100 = 0;

  Object.values(industryMap).forEach(row => {
    const dual = row['ทวิภาคี'];
    const full = row['100%'];
    const total = dual + full;

    totalDual += dual;
    total100 += full;

    rows.push({
      'อุตสาหกรรม': row['อุตสาหกรรม'],
      'ผู้สำเร็จการศึกษา': String(total),
      'ทวิภาคี': String(dual),
      '100%': String(full),
      'สัดส่วน (%)': total > 0
        ? ((dual / total) * 100).toFixed(1)
        : '0.0'
    });
  });

  // 3) แถวรวม (Grand total)
  const grandTotal = totalDual + total100;

  rows.push({
    'อุตสาหกรรม': 'รวม',
    'ผู้สำเร็จการศึกษา': String(grandTotal),
    'ทวิภาคี': String(totalDual),
    '100%': String(total100),
    'สัดส่วน (%)': grandTotal > 0
      ? ((totalDual / grandTotal) * 100).toFixed(1)
      : '0.0'
  });

  return {
    columnName: [
      'อุตสาหกรรม',
      'ผู้สำเร็จการศึกษา',
      'ทวิภาคี',
      '100%',
      'สัดส่วน (%)'
    ],
    rows
  };
};

export const typeAEnterpriseData = (rawData = []) => {
  const industryMap = {};
  const labels = [];

  rawData?.forEach(item => {
    const industry = item.target_industries || 'อื่นๆ';
    const type = item.student_type;
    const count = Number(item.enterprise_count) || 0;

    if (!industryMap[industry]) {
      industryMap[industry] = {
        'ทวิภาคี': 0,
        '100%': 0
      };
      labels.push(industry);
    }

    if (type === 'ทวิภาคี') {
      industryMap[industry]['ทวิภาคี'] += count;
    }

    if (type === '100%') {
      industryMap[industry]['100%'] += count;
    }
  });

  return {
    labels,
    datasets: [
      {
        label: 'ทวิภาคี',
        data: labels.map(l => industryMap[l]['ทวิภาคี'])
      },
      {
        label: '100%',
        data: labels.map(l => industryMap[l]['100%'])
      }
    ]
  };
};

export const typeAEnterpriseDataTable = (rawData = []) => {
  const industryMap = {};
  let grandTotal = 0;

  // รวมข้อมูลตามอุตสาหกรรม
  rawData?.forEach(item => {
    const industry = item.target_industries || 'อื่นๆ';
    const type = item.student_type;
    const count = Number(item.enterprise_count) || 0;

    if (!industryMap[industry]) {
      industryMap[industry] = {
        'ทวิภาคี': 0,
        '100%': 0
      };
    }

    if (type === 'ทวิภาคี') {
      industryMap[industry]['ทวิภาคี'] += count;
    }

    if (type === '100%') {
      industryMap[industry]['100%'] += count;
    }

    grandTotal += count;
  });

  // สร้าง rows
  const rows = Object.entries(industryMap).map(([industry, values]) => {
    const total = values['ทวิภาคี'] + values['100%'];
    const percent =
      grandTotal > 0 ? ((total / grandTotal) * 100).toFixed(2) : '0.00';

    return {
      'อุตสาหกรรม': industry,
      'จำนวนสถานประกอบการ': total.toString(),
      'ทวิภาคี': values['ทวิภาคี'].toString(),
      '100%': values['100%'].toString(),
      'สัดส่วน (%)': percent
    };
  });

  return {
    columnName: [
      'อุตสาหกรรม',
      'จำนวนสถานประกอบการ',
      'ทวิภาคี',
      '100%',
      'สัดส่วน (%)'
    ],
    rows
  };
};

export const matchingData = (rawData = []) => {
  const industryMap = {};
  const labels = [];

  rawData?.forEach(item => {
    const industry = item.name;
    const supply = Number(item.supply) || 0;
    const demand = Number(item.demand) || 0;

    if (!industryMap[industry]) {
      industryMap[industry] = {
        supply: 0,
        demand: 0
      };
      labels.push(industry);
    }

    industryMap[industry].supply += supply;
    industryMap[industry].demand += demand;
  });

  return {
    labels,
    datasets: [
      {
        label: 'ผลผลิต',
        data: labels.map(l => industryMap[l].supply)
      },
      {
        label: 'ความต้องการ',
        data: labels.map(l => industryMap[l].demand)
      }
    ]
  };
};

export const matchingDataTable = (rawData = []) => {
  return {
    columnName: [
      'อุตสาหกรรม',
      'ผลผลิตกำลังคน',
      'ความต้องการกำลังคน',
      'กำลังคนขาด/เกิน (คน)',
      'กำลังคนขาด/เกิน (%)'
    ],
    rows: rawData?.map(item => {
      const supply = Number(item.supply) || 0;
      const demand = Number(item.demand) || 0;

      // ขาด (-) / เกิน (+)
      const diff = supply - demand;
      const diffPercent =
        supply === 0
          ? 0
          : ((diff / supply) * 100);

      return {
        'อุตสาหกรรม': item.name || '-',
        'ผลผลิตกำลังคน': supply.toString(),
        'ความต้องการกำลังคน': demand.toString(),
        'กำลังคนขาด/เกิน (คน)': diff.toString(),
        'กำลังคนขาด/เกิน (%)': diffPercent.toFixed(0)
      };
    })
  };
};